const authEn = {
    auth: {
        // Login
        login: {
            title: "Sign In",
            subtitle: "Access your account",
            description: "Enter your credentials to continue",
            welcome: "Welcome back!",
            submitButton: "Sign In",
            loading: "Signing in...",
            forgotPassword: "Forgot your password?",
            noAccount: "Don't have an account?",
            createAccount: "Create account",
        },



        // Logout
        logout: {
            button: "Sign Out",
            loading: "Signing out...",
            confirm: "Are you sure you want to sign out?",
            success: "Signed out successfully",
        },

        // Forms
        form: {
            email: {
                label: "Email Address",
                placeholder: "your@email.com",
            },
            password: {
                label: "Password",
                placeholder: "Your password",
            },
            name: {
                label: "Full Name",
                placeholder: "Your full name",
            },
            confirmPassword: {
                label: "Confirm Password",
                placeholder: "Confirm your password",
            },
            currentPassword: {
                label: "Current Password",
                placeholder: "Your current password",
            },
            newPassword: {
                label: "New Password",
                placeholder: "Your new password",
            },
        },

        // Errors
        errors: {
            required: "This field is required",
            email: "Invalid email format",
            passwordLength: "Password must be at least 8 characters",
            passwordMatch: "Passwords don't match",
            userNotFound: "User not found",
            wrongPassword: "Incorrect password",
            invalidCredentials: "Invalid credentials",
            emailTaken: "This email is already registered",
            genericError: "An error occurred. Please try again.",
            networkError: "Connection error. Check your internet.",
            serverError: "Server error. Please try again later.",
            loadUserDataTitle: "Error loading user data",
            loadUserDataDescription: "We couldn't load your account data. Please try signing in again.",
            retryLogin: "Sign in again",
        },

        // Success messages
        success: {
            loginSuccess: "Welcome back!",
            logoutSuccess: "Signed out successfully",
        },

        // Password Reset
        forgotPassword: {
            title: "Forgot Password",
            description: "We'll send you a link to reset your password",
            submitButton: "Send Link",
            loading: "Sending link...",
            success: "Link sent. Check your email.",
            backToLogin: "Back to login",
        },

        resetPassword: {
            title: "Reset Password",
            description: "Enter your new password",
            submitButton: "Reset",
            loading: "Resetting...",
            success: "Password reset successfully",
        },

        // Email Verification
        emailVerification: {
            title: "Verify Email",
            description: "We've sent a verification link to your email",
            resendButton: "Resend Link",
            loading: "Resending...",
            success: "Link resent successfully",
            verified: "Email verified successfully",
        },

        // Profile
        profile: {
            title: "My Profile",
            updateButton: "Update Profile",
            loading: "Updating...",
            changePassword: "Change Password",
            changePasswordButton: "Change",
            loadingPassword: "Changing password...",
        },

        // Permissions
        permissions: {
            accessDenied: "You don't have permission to access this page",
            insufficientPermissions: "Insufficient permissions",
        },

        // Status
        status: {
            loading: "Loading...",
            authenticating: "Authenticating...",
            redirecting: "Redirecting...",
        }
    }
};

export default authEn; 